export abstract class PageBreakRules {
  abstract title: string;
  abstract subTitle: string;
  abstract requiredInfoContainerClass: string;
  abstract ssImage: string;
  abstract idTitle: string;
  abstract idImage: string;
  abstract mobileImage: string;
  abstract mobileDescription: string;
  abstract faqUrl: string;
}
